// Halaman AWAM: /verifikasi/:no — semak kesahihan resit via QR.
// Tiada login. Hanya panggil RPC verify_receipt (field terhad).
import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ShieldCheck, ShieldX, Loader2, Search } from 'lucide-react';
import { supabase } from '../lib/supabaseClient';
import { formatRM } from '../lib/format';

const KAEDAH = { tunai: 'Tunai', transfer: 'Pindahan Bank', qr_manual: 'QR Manual' };

export default function VerifikasiResit() {
  const { t } = useTranslation();
  const { no } = useParams();
  const [input, setInput] = useState(decodeURIComponent(no || ''));
  const [state, setState] = useState('idle'); // idle | loading | sah | tidak
  const [data, setData] = useState(null);

  const semak = async (noResit) => {
    const q = (noResit || '').trim();
    if (!q) return;
    setState('loading');
    const { data: rows, error } = await supabase.rpc('verify_receipt', { p_no: q });
    if (error || !rows || rows.length === 0) { setState('tidak'); return; }
    const r = rows[0];
    if (r.sah) { setData(r); setState('sah'); }
    else setState('tidak');
  };

  useEffect(() => { if (no) semak(decodeURIComponent(no)); }, [no]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-brand to-brand-royal flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-card rounded-3xl shadow-2xl p-8">
        <div className="text-center">
          <img src="/mtsrpay-logo.webp" alt="MTSRpay" className="h-14 mx-auto mb-3" />
          <h1 className="text-xl font-black text-foreground">{t('verifikasiResit')}</h1>
          <p className="text-sm text-muted-foreground mt-1">{t('verifikasiDesc')}</p>
        </div>

        <div className="mt-6 flex gap-2">
          <input
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && semak(input)}
            placeholder={t('cthNoResit')}
            className="flex-1 h-11 px-4 rounded-xl border border-border text-sm font-mono focus:outline-none focus:ring-2 focus:ring-brand"
            data-testid="verify-input"
          />
          <button onClick={() => semak(input)} disabled={state === 'loading'}
            className="h-11 px-4 rounded-xl bg-brand text-white font-bold text-sm hover:bg-brand-royal flex items-center gap-1.5">
            {state === 'loading' ? <Loader2 className="h-4 w-4 animate-spin" /> : <Search className="h-4 w-4" />}
            {t('semak')}
          </button>
        </div>

        {state === 'sah' && data && (
          <div className="mt-6 rounded-2xl border-2 border-emerald-200 dark:border-emerald-800 bg-emerald-50 dark:bg-emerald-950 p-5 text-center" data-testid="verify-sah">
            <ShieldCheck className="h-12 w-12 text-emerald-600 dark:text-emerald-400 mx-auto" />
            <p className="mt-2 text-lg font-black text-emerald-700 dark:text-emerald-300">{t('resitSah')}</p>
            <div className="mt-4 text-left text-sm space-y-1.5">
              <div className="flex justify-between"><span className="text-muted-foreground">No. Resit</span><span className="font-mono font-bold text-foreground">{data.no_resit}</span></div>
              <div className="flex justify-between"><span className="text-muted-foreground">{t('sekolah')}</span><span className="font-semibold text-foreground text-right">{data.nama_sekolah}</span></div>
              <div className="flex justify-between"><span className="text-muted-foreground">{t('jumlah')}</span><span className="font-mono font-bold text-foreground">{formatRM(data.jumlah_rm)}</span></div>
              <div className="flex justify-between"><span className="text-muted-foreground">{t('kaedah')}</span><span className="font-semibold text-foreground">{KAEDAH[data.kaedah] || data.kaedah}</span></div>
              <div className="flex justify-between"><span className="text-muted-foreground">{t('tarikh')}</span><span className="font-semibold text-foreground">{new Date(data.tarikh).toLocaleDateString('ms-MY', { dateStyle: 'long' })}</span></div>
            </div>
          </div>
        )}

        {state === 'tidak' && (
          <div className="mt-6 rounded-2xl border-2 border-red-200 dark:border-red-800 bg-red-50 dark:bg-red-950 p-5 text-center" data-testid="verify-tidak">
            <ShieldX className="h-12 w-12 text-red-500 mx-auto" />
            <p className="mt-2 text-lg font-black text-red-600 dark:text-red-400">{t('resitTidakSah')}</p>
            <p className="text-sm text-red-500 mt-1">{t('resitTidakSahDesc')}</p>
          </div>
        )}

        <p className="mt-6 text-center text-xs text-muted-foreground">
          <Link to="/masuk" className="text-brand font-semibold hover:underline">MTSRpay</Link> · {t('verifikasiNota')}
        </p>
      </div>
    </div>
  );
}
